import { useEffect } from 'react';
import { useTripStore } from '../store/tripStore';

export function useUndoKeyboard() {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't intercept when typing in inputs
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT' ||
        target.isContentEditable
      ) {
        return;
      }

      const mod = e.metaKey || e.ctrlKey;
      if (!mod) return;

      // Ctrl+Z / Cmd+Z → undo
      if (e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        useTripStore.getState().undo();
        return;
      }

      // Ctrl+Shift+Z / Cmd+Shift+Z → redo
      if (e.key === 'z' && e.shiftKey) {
        e.preventDefault();
        useTripStore.getState().redo();
        return;
      }

      // Ctrl+Y / Cmd+Y → redo
      if (e.key === 'y') {
        e.preventDefault();
        useTripStore.getState().redo();
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}
